export default function PHP_min() {
  return (
    <div>
      <h1>PHP_min</h1>
    </div>
  );
}
